<template>
  <div class="container">
    <table class="table">
      <!-- NOTE: HEADER -->
      <thead>
        <tr>
          <th scope="col" />
          <th
            v-if="pageType === 'adminSetting'"
            scope="col"
          >
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.user === 'asc',
                'table-sort-down': sortObj.user === 'desc'
              }"
              @click="changeSortType('user')"
            >
              {{ $t("SmartScheduling.Dashboard.ScheduledUser") }}
            </button>
          </th>
          <th
            scope="col text-center"
            align="center"
          >
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.adjustmentRequest === 'asc',
                'table-sort-down': sortObj.adjustmentRequest === 'desc'
              }"
              @click="changeSortType('adjustmentRequest')"
            >
              {{ $t("SmartScheduling.Dashboard.AdjustmentRequest") }}
            </button>
          </th>
          <th scope="col text-center">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.scheduleRegistration === 'asc',
                'table-sort-down': sortObj.scheduleRegistration === 'desc'
              }"
              @click="changeSortType('scheduleRegistration')"
            >
              {{ $t("SmartScheduling.Dashboard.ScheduleRegistration") }}
            </button>
          </th>
          <th scope="col text-center">
            <button
              type="button"
              class="btn btn-borderless-primary table-sort table-center"
              :class="{
                'table-sort-up': sortObj.timeCreated === 'asc',
                'table-sort-down': sortObj.timeCreated === 'desc'
              }"
              @click="changeSortType('timeCreated')"
            >
              {{ $t("SmartScheduling.Dashboard.TimeCreated") }}
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in filterdItems"
          :key="item.key"
          class="table-padding"
        >
          <td class="table-center">
            {{ item.time }}
          </td>
          <td
            v-if="pageType === 'adminSetting'"
            class="table-center"
          >
            {{ item.createUserCount }}
          </td>
          <td class="table-center">
            {{ item.schedulingCount }}
          </td>
          <td class="table-center">
            {{ item.registerCount }}
          </td>
          <td class="table-center">
            {{ item.createdTime }}
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="table-empty"
      v-if="!filterdItems.length"
    >
      <div class="table-empty-label">
        {{ $t("General.NoData") }}
      </div>
    </div>
    <!-- NOTE: pagenatino -->
    <nav
      class="pagination"
      v-else
    >
      <p>
        {{ `${pagenationCount.start} - ${pagenationCount.end} of ${pagenationCount.all}` }}
      </p>
      <VSelectbox
        class="pagenation-step"
        :items="stepArray"
        select-id="select-step"
        size="sm"
        @selectedData="pageStep = $event"
      />
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.start <= 1}"
          @click="subPagenationIndex"
        >
          <i class="fas fa-chevron-left" />
        </button>
        <button
          type="button"
          class="btn btn-toolbar"
          :class="{'disabled':pagenationCount.end >= pagenationCount.all}"
          @click="addPagenationIndex"
        >
          <i class="fas fa-chevron-right" />
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import VSelectbox from '@/components/VSelectbox'
export default {
  components: {
    VSelectbox
  },
  props: {
    dashboardData: {
      type: Array,
      default: () => ([])
    },
    pageType: {
      type: String,
      default: 'scheduling'
    }
  },
  data: () => ({
    sortObj: {
      user: false,
      adjustmentRequest: false,
      scheduleRegistration: false,
      timeCreated: false,
    },
    pageIndex: 0,
    pageStep: 10,
  }),
  computed: {
    filterdItems() {
      if (this.dashboardData.length < 1) return []
      return [].concat(this.dashboardData).map((arr) => {
        const time = (this.pageType === 'adminSetting' || !arr.start) ? arr.target : `${arr.start} ~ ${arr.end}`
        const days = (Number(arr.days) <= 0) ?
          '' :
          `${String(arr.days).padStart(2, '0')}${this.$t('SmartScheduling.Dashboard.Days')} `
        const hours = (days === '' && Number(arr.hours) <= 0) ?
          '' :
          `${String(arr.hours).padStart(2, '0')}${this.$t('SmartScheduling.Dashboard.Hours')} `
        const minutes = `${String(arr.minutes).padStart(2, '0')}${this.$t('SmartScheduling.Dashboard.Minutes')} `
        const createdTime = days + hours + minutes
        return {
          time,
          createUserCount: arr.createUserCount,
          registerCount: arr.registerCount,
          schedulingCount: arr.schedulingCount,
          createdTime,
          createdTimeSecond: (arr.days * 24 * 60 * 60) + (arr.hours * 60 * 60) + (arr.minutes * 60) + arr.seconds
        }
      }).sort((a, b) => {
        if (!this.sortObj.user) return true
        return this.sort(a.createUserCount, b.createUserCount, this.sortObj.user === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.adjustmentRequest) return true
        return this.sort(a.registerCount, b.registerCount, this.sortObj.adjustmentRequest === 'asc')
      }).sort((a, b) => {
        if (!this.sortObj.scheduleRegistration) return true
        return this.sort(a.schedulingCount, b.schedulingCount, this.sortObj.scheduleRegistration === 'asc')
      }).sort((a, b) => {
        if (!this.timeCreated) return true
        return this.sort(a.createdTimeSecond, b.createdTimeSecond, this.timeCreated === 'asc')
      }).slice(this.pagenationCount.start - 1, this.pagenationCount.end)
    },
    pagenationCount() {
      if (!Array.isArray(this.dashboardData)) return { all: 0, start: 0, end: 0 }
      const all = this.dashboardData.length
      const start = (this.pageStep * this.pageIndex) + 1
      const end = (this.pageStep * (this.pageIndex + 1))
      return {
        all,
        start,
        end: (end < all) ? end : all
      }
    },
    stepArray() {
      return [5, 10, 25, 50, 100].map((arr) => ({
        text: arr,
        value: arr,
        selected: this.pageStep === arr
      }))
    },
  },
  methods: {
    changeSortType(target) {
      if (!this.sortObj[target]) {
        this.$set(this.sortObj, target, 'asc')
      } else if (this.sortObj[target] === 'asc') {
        this.$set(this.sortObj, target, 'desc')
      } else {
        this.$set(this.sortObj, target, false)
      }
    },
    sort(a, b, isAsc) {
      if (typeof a == 'string' || a instanceof String) {
        if (isAsc) return (a < b) ? -1 : 1
        return (a < b) ? 1 :-1
      }
      if (isAsc) return b - a
      return a - b
    },
    subPagenationIndex() {
      if (this.pagenationCount.start <= 1) return false
      this.pageIndex -= 1
    },
    addPagenationIndex() {
      if (this.pagenationCount.end >= this.pagenationCount.all) return false
      this.pageIndex += 1
    },
  }
}
</script>

<style lang="scss" scoped>
.table-center {
  text-align: center;
}
button {
  &.table-center {
    display: block;
    margin: auto;
  }
}
.table-padding {
  padding: 12px;
}
</style>
